// extracted by mini-css-extract-plugin
export default {"wrapper":"JjDy67ISPReEryiG5oQd","action":"f7xHpWW_EtBBPnInu5xL","actionIcon":"ewmnqS4I11UjXC3zwv1B","actionLabel":"TKq3cVjnVnTD9qr0ERg4"};